import { Injectable } from '@angular/core';

@Injectable()
export class CommonComponents {
    public static patientId: number;
    public static patientName: string;
    public static userName: string;
    public static encounterId: string;
    public static pumpRefillVisibility: boolean = false;
    public static headerVisibility: boolean = true;
    public static patientGender: string;
    public static patientAge: string;
    public static visitNoteStatus: string;
    public static orNoteStatus: string;
    public static physicianName: string;
    public static locationId: number;
    public static demoheaderVisibility: boolean = true;
    public static ordernoteheaderVisibility: boolean = true;
    public static visitNoteAlertsheaderVisibility: boolean = true;
}